<template>
  <div
    class="dict-list-content"
    :style="`padding-bottom: ${max > 1 ? 64 : 0}px`"
  >
    <van-index-bar
      :index-list="indexList"
      :highlight-color="theme ==='orange'? '#FF6C0E': '#E38400'"
      @select="handleClickIndex"
      ref="indexBar"
    >
      <!-- <div>
        <div class="dict__list-selected-box">
          <van-index-anchor index="已选" />
          (<span class="dict__list-count_checked">{{ selectInfo.length }}</span>
          /{{ max }})
        </div>
        <div class="dict__list-notselected" v-if="selectInfo.length === 0">
          - 未选择 -
        </div>
        <div class="dict__list-selected-tag-container">
          <div
            v-for="item in selectInfo"
            :key="item.code"
            class="dict__list-selected-tag tag-item"
            size="medium"
            id="primary"
          >
            <span class="tag-item-text">{{ item.value }}</span>
            <span class="icon-delete" @click="handleDelete(item)"></span>
          </div>
        </div>
      </div> -->

      <div v-for="item in citySource" :key="item.title" class="sub-list_wrapper">
        <van-index-anchor :index="item.title" :class="item.type === '1'?'hot-city-title':''" />
        <div class="dict__list-content-box">
          <div
            :class="{
              'dict__list-content-active': selectCode.includes(row.code),
            }"
            class="dict__list-content"
            v-for="row in item.items"
            :key="row.value"
            @click="handleClick(row)"
          >
            <span
              class="dict__list-content-text"
              :class="{
                'dict__list-content-text-active': selectCode.includes(row.code),
              }"
            >
              {{ row.value }}</span
            >
          </div>
        </div>
      </div>
    </van-index-bar>
  </div>
</template>

<script>
// import { getCityDictData } from "../../apis/index";
// import dataSource from "../../static-data/city";
import { IndexBar, IndexAnchor, Toast, Tag } from "vant";
export default {
  name: "dictList",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Tag.name]: Tag,
  },
  props: {
    id: {
      type: String,
    },
    max: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: 0,
    },
    list: {
      type: Array,
      required: true,
    },
    // active: {
    //   type: Number,
    //   required: false,
    //   default: 0,
    // },
    selectValue: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
    isSubmit: {
      type: Boolean,
      required: false,
    },
    theme: {
      type: String,
      required: false,
      default: () => "yellow", //orange-社招 yellow-校招
    },
    // 选中对象数组
    selectdItems: {
      type: Array,
      default: () => [],
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
    newHotCityInfo: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      active: 0,
      indexList: [], // 索引字符
      citySource: [],
      selectInfo: [], //选中的code、value
      currentIndex: 0,
    };
  },
  watch: {
    selectInfo() {
      this.$emit('update:selectdItems', this.selectInfo);
    },
    selectValue(selectedIts) {
      if (JSON.stringify(selectedIts) != JSON.stringify(this.selectInfo)) {
        this.selectInfo = [...selectedIts];
      }
    },
    isSubmit(val) {
      if (val) {
        this.$emit("handleSubmit", {
          code: this.selectCode.join(","),
          val: this.selectVal.join(","),
          selects: this.selectInfo,
        });
      }
    },
  },
  computed: {
    selectCode() {
     return this.selectInfo.map(el => el.code); 
    },
    selectVal() {
      return this.selectInfo.map(el => el.value); 
    },
  },
  created() {
    if(this.componentConfig.activeCityList.length > 0){
      this.citySource.push(this.newHotCityInfo)
    }else{
      // const res = await getCityDictData()
      // 字典热门城市换热门
      const hotIndex = this.list.findIndex(el => el.type === '1');
      hotIndex !== -1 && (this.list[hotIndex].title = '热门');
      this.indexList = this.list.map((item) => item.title);
      this.indexList.unshift("已选");
      // this.indexList[this.indexList.indexOf("热门城市")] = "热门";
      this.citySource = [...this.list];
    }
    
    // 默认选中数据
    if (JSON.stringify(this.selectValue) != JSON.stringify(this.selectInfo)) {
      this.selectInfo = [...this.selectValue];
    }
  },
  methods: {
    handleRightItem(data) {
      this.$emit("clickItem", data);
    },
    handleClick(data) {
      const { selectInfo, max, min } = this;
      const selectedIndex = selectInfo.findIndex(el => el.code === data.code);
      if (selectedIndex > -1) {
        // 取消选中之前判断是否满足最小值
        if (min > 1 && selectInfo.length <= min) {
          // 如果选中数量已经小于或者等于最小数，则不可以在删除
          Toast('最少选择' + min + '项');
          return;
        }
        selectInfo.splice(selectedIndex, 1);
      } else if (selectInfo.length < max) {
        selectInfo.push(data);
      } else {
        Toast(`最多只能选择${max}项`);
      }
      this.$emit('saveBtn', data)
    },
    handleDelete(item) {
      if (this.min > 1 && this.selectInfo.length <= this.min) {
        // 如果选中数量已经小于或者等于最小数，则不可以在删除
        Toast('最少选择' + this.min + '项');
        return;
      }
      const index = this.selectInfo.findIndex(el => el.code === item.code);
      index !== -1 && this.selectInfo.splice(index, 1);
    },
    handleClickIndex(data) {
      this.currentIndex = data;
      this.$toast({
        message: data,
        duration: 2000,
        className: `index-toast jbs-toast-${this.theme}`, // 自定义类名
      });
    },
  },
};
</script>
<style>
.index-toast {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  font-weight: 500;
  font-size: 18px;
}
.index-toast.jbs-toast-yellow {
  background-color: #ffd74d;
  color: #222222;
}
.index-toast.jbs-toast-orange {
  background-color: #FF6C0E;
  color: #fff;
}
/* .van-toast--text {
  min-width: 56px;
  height: 56px;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  padding: 5px;
} */
.van-index-anchor {
  font-size: 16px;
  font-weight: bold !important;
  color: #222222;
  line-height: 20px;
  margin-left: 15px;
}
.sub-list_wrapper {
  margin-bottom: 24px;
  margin-top: 10px;
}
</style>
<style lang="less" scoped>
::v-deep .van-tag__close {
  font-size: 20px;
  transform: scale(0.5);
}
::v-deep .van-index-bar__index {
  padding: 0 3px 0 16px;
  line-height: 18px;
}
.index-toast__icon {
  color: #ffffff;
}
v-deep .van-index-anchor--sticky {
  color: #222222;
}
::v-deep .van-tag--default {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #e38400;
  font-size: 14px;
  width: 103px;
  height: 42px;
  background: #fff9e4;
  border-radius: 4px;
  margin-right: 8px;
  margin-bottom: 5px;
  border: 1px solid #ffe48c;
  box-sizing: border-box;
  float: left;
}
::v-deep .van-index-bar{
  width: 100%;
}
::v-deep .van-index-bar__sidebar{
  position: fixed;
  top: 50px;
  right: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  span{
    padding: 0 2px;
    width: 40px;
  }
}

.hot-city-title ::v-deep .van-index-anchor:not(.van-index-anchor--sticky)::after {
  content: '城市';
}
.dict__list {
  &-count_checked {
    color: var(--activeColor);
  }
  &-selected-tag-container {
    // display: flex;
    // flex-wrap: wrap;
    padding: 16px 0 24px 16px;
    position: relative;
    overflow: hidden;
    .tag-item {
      margin-bottom: 8px;
      float: left;
      position: relative;
      box-sizing: border-box;
      .icon-delete {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("@/assets/img/activity/icon-delete.png") no-repeat;
        background-size: 8px 8px;
        background-position: center;
        position: absolute;
        right: 0;
      }
    }
  }
  &-selected-tag {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    color: var(--activeColor);
    font-size: 14px;
    width: 103px;
    height: 42px;
    background: var(--selecteBg);
    border-radius: 4px;
    margin-right: 8px;
    border: 1px solid var(--selectBorder);
    
    .tag-item-text {
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 0 4px;
    }
  }
  &-selected-box {
    padding-top: 20px;
    display: flex;
  }
  &-notselected {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #cbced4;
    font-size: 14px;
    width: 103px;
    height: 42px;
    border-radius: 4px;
    border: 1px dashed #cbced4;
    margin: 16px 0 32px 16px;
  }
  &-content-box {
    // display: flex;
    // flex-wrap: wrap;
    // padding-left: 16px;
    // padding-top: 16px;
    padding: 16px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 5px;
  }
  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 103px;
    height: 42px;
    background: #f7f7f7;
    border-radius: 4px;
    // margin: 0 8px 8px 0;
    margin: 4px;
    &-active {
      box-sizing: border-box;
      height: 42px;
      background: var(--selecteBg);
      border-radius: 4px;
      border: 1px solid var(--selectBorder);
    }
  }
  &-content-text {
    font-size: 14px;
    font-weight: 400;
    color: #444444;
    line-height: 20px;
    padding: 0 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &-content-text-active {
    font-size: 14px;
    font-weight: 500;
    color: var(--activeColor);
    line-height: 20px;
  }
}
::v-deep .van-index-anchor--sticky {
  color: #222222 !important;
}
::v-deep .van-index-anchor {
  height: 20px;
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  line-height: 20px;
}

.dict-list-content {
  border-top: 1px solid #edeff2;
  flex: 1;
  display: flex;
  overflow: hidden;
  overflow-y: scroll;
}
.dict-list-content .left-list-content {
  border-right: 1px solid #edeff2;
  overflow: auto;
}
.dict-list-content .left-list-content .left-tips {
  width: 100%;
  height: 49px;
  line-height: 49px;
  font-size: 14px;
  font-weight: 400;
  color: #222;
  padding-left: 16px;
}
.dict-list-content .left-list-content .list-item {
  font-size: 14px;
  font-weight: 400;
  color: #222;
  line-height: 17px;
  padding: 16px;
  position: relative;
}
.dict-list-content .left-list-content .list-item.active {
  color: var(--activeColor);
}
.dict-list-content .left-list-content .list-item.active:before {
  content: "";
  position: absolute;
  width: 3px;
  height: 19px;
  background: var(--activeLineColor);
  left: 0;
  top: 50%;
  margin-top: -9.5px;
}
.dict-list-content .right-list-content {
  flex: 1;
  padding: 0 16px;
  overflow: auto;
}
.scroll-wrapper {
  overflow: hidden;
}
.dict-list-content .right-list-content .sub-list-content {
  overflow: hidden;
  padding-bottom: 16px;
}
.dict-list-content .right-list-content .sub-list-content .sub-list-title {
  padding: 16px 0;
  font-size: 16px;
  font-weight: 500;
  color: #222;
  line-height: 22px;
  float: left;
  width: 100%;
}
.dict-list-content .right-list-content .sub-list-content .list-item {
  background: #f5f6f7;
  border-radius: 4px;
  height: 38px;
  text-align: center;
  width: calc((100% - 9px) / 2);
  margin-top: 8px;
  box-sizing: border-box;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  float: left;
}
.dict-list-content
  .right-list-content
  .sub-list-content
  .list-item:nth-child(2n - 1) {
  margin-left: 9px;
}
.dict-list-content .right-list-content .sub-list-content .list-item span {
  font-size: 12px;
  font-weight: 400;
  color: #222;
  line-height: 15px;
  margin: 0 8px;
}
.dict-list-content .right-list-content .sub-list-content .list-item.active {
  background: var(--selecteBg);
  border-radius: 4px;
  border-color: var(--selectBorder);
}
.dict-list-content
  .right-list-content
  .sub-list-content
  .list-item.active
  span {
  font-weight: 600;
  color: var(--activeColor);
}
</style>
